import * as React from 'react';

import {Stack} from 'shells/layout/stack/stack';

import type {Lead as LeadFragment} from 'nutshell-graphql-types';

import {LeadCloseDate} from '../shared/components/lead-close-date';
import {LeadConfidence} from '../shared/components/lead-confidence';
import {LeadOpenedBy} from '../shared/components/lead-opened-by';
import {LeadOpenedOn} from '../shared/components/lead-opened-on';
import {LeadOutcomeReason} from '../shared/components/lead-outcome-reason';
import {LeadTerritory} from '../shared/components/lead-territory';

type Props = {
    lead: LeadFragment;
    onUpdateLeadConfidence: (arg1: number) => void;
    onUpdateLeadCreatedDate: (arg1?: Date | null | undefined) => void;
    onUpdateLeadDueDate: (arg1?: Date | null | undefined) => void;
    onUpdateLeadClosedDate: (arg1?: Date | null | undefined) => void;
};

export function HeaderStats(props: Props) {
    return (
        <Stack isHorizontal={true} spacing={32} wrap={true}>
            <LeadOpenedBy lead={props.lead} />
            <LeadOpenedOn
                createdTime={props.lead.createdTime}
                onUpdateLeadCreatedDate={props.onUpdateLeadCreatedDate}
            />
            <LeadCloseDate
                lead={props.lead}
                onUpdateLeadDueDate={props.onUpdateLeadDueDate}
                onUpdateLeadClosedDate={props.onUpdateLeadClosedDate}
            />
            <LeadConfidence
                // @ts-expect-error
                lead={props.lead}
                value={props.lead.confidence}
                onUpdate={props.onUpdateLeadConfidence}
            />
            {props.lead.territory && <LeadTerritory territory={props.lead.territory} />}
            {props.lead.status === 'LOST' && props.lead.outcome && props.lead.outcome.name && (
                <LeadOutcomeReason outcome='LOST' reason={props.lead.outcome.name} />
            )}
            {props.lead.status === 'CANCELLED' && props.lead.outcome && props.lead.outcome.name && (
                <LeadOutcomeReason outcome='CANCELLED' reason={props.lead.outcome.name} />
            )}
        </Stack>
    );
}
